module.exports = __webpack_public_path__ + "img/ic-ic-safe-btn-arrow-sw.1e40b10c.svg";